var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('block-content');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { ContentNode } from './content-node';
import { ContentTitle } from '../elements/content-title';
import { useEntity } from '../hooks/use-entity';
export var BlockContentDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", "em;\n    margin-bottom: ", ";\n  "], ["\n    color: ", ";\n    font-size: ", "em;\n    margin-bottom: ", ";\n  "])), theme.COLOR('secondary'), 18 / 15, theme.UNIT(1))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 0 ", ";\n  "], ["\n    margin: 0 0 ", ";\n  "])), theme.UNIT(4))
});
var ContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: styled(ContentTitle)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: styled.h3.attrs(cls.attr('subtitle'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Content: styled(ContentNode)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var BlockContent = function (props) {
  var className = props.className,
    children = props.children;
  var entity = useEntity(props.entity);
  var title = entity.title,
    subtitle = entity.subtitle,
    content = entity.content;
  var hasContent = content && content.text;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, title && React.createElement(My.Title, {
    tag: "h2"
  }, title), subtitle && React.createElement(My.Subtitle, null, subtitle), hasContent && React.createElement(My.Content, {
    entity: content
  }), children);
};
BlockContent.defaultProps = BlockContentDefaultProps;
BlockContent.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;